// import React, { useContext, useEffect, useState } from 'react';
// import { ContentListGlobal } from '../contentList/contentListGlobal';
// import { useAuthCtx } from '../../../features/auth_v2/hooks/useAuthCtx';
// import { NoAccessToAnyContent } from './NoAccessToAnyContent';
// import { CollapseContainer } from './styles';
// import { GlobalFiltersContext } from './GlobalFiltersContext';
// import { IAChat } from '../global/IAChat';

// export const Home = () => {
//   const { session } = useAuthCtx();

//   const { searchType } = useContext(GlobalFiltersContext);

//   const [hasAccessToPeriodics, setHasAccessToPeriodics] = useState(false);
//   const [hasAccessToBooks, setHasAccessToBooks] = useState(false);
//   const [hasAccessToVideos, setHasAccessToVideos] = useState(false);
//   const [hasAccessToInformatives, setHasAccessToInformatives] = useState(false);
//   const [hasPlatformAll, setHasPlatformAll] = useState(false);

//   const contractedTags = session.client.contracted_tags || [];

//   useEffect(() => {
//     setHasAccessToPeriodics(
//       contractedTags.some((result) => result.id.startsWith('periodic'))
//     );

//     setHasAccessToBooks(
//       contractedTags.some((result) => result.id.startsWith('book'))
//     );

//     setHasAccessToVideos(
//       contractedTags.some((result) => result.id.startsWith('video'))
//     );
//     setHasAccessToInformatives(
//       contractedTags.some((result) => result.id.startsWith('news'))
//     );
//     setHasPlatformAll(
//       contractedTags.some((result) => result.id === 'platform-all')
//     );
//   }, []);

//   const hasAccesToSomeContent =
//     Boolean(session.client.all_content_view) ||
//     hasAccessToPeriodics ||
//     hasAccessToBooks ||
//     hasAccessToVideos ||
//     hasAccessToInformatives ||
//     hasPlatformAll;

//   return (
//     <>
//       {hasAccesToSomeContent ? <></> : <NoAccessToAnyContent />}
//       <CollapseContainer>
//         {searchType === 'ai' ? <IAChat /> : <ContentListGlobal />}
//       </CollapseContainer>
//     </>
//   );
// };
import React, { useContext, useEffect, useState } from 'react';
import { ContentListGlobal } from '../contentList/contentListGlobal';
import { useAuthCtx } from '../../../features/auth_v2/hooks/useAuthCtx';
import { NoAccessToAnyContent } from './NoAccessToAnyContent';
import { CollapseContainer } from './styles';
import { GlobalFiltersContext } from './GlobalFiltersContext';
import { IAChat } from '../global/IAChat';
import { Alert } from 'antd';

export const Home = () => {
  const { session } = useAuthCtx();

  const { searchType } = useContext(GlobalFiltersContext);

  const [hasAccessToPeriodics, setHasAccessToPeriodics] = useState(false);
  const [hasAccessToBooks, setHasAccessToBooks] = useState(false);
  const [hasAccessToVideos, setHasAccessToVideos] = useState(false);
  const [hasAccessToInformatives, setHasAccessToInformatives] = useState(false);
  const [hasPlatformAll, setHasPlatformAll] = useState(false);

  const contractedTags = session.client.contracted_tags || [];

  useEffect(() => {
    setHasAccessToPeriodics(
      contractedTags.some((result) => result.id.startsWith('periodic'))
    );

    setHasAccessToBooks(
      contractedTags.some((result) => result.id.startsWith('book'))
    );

    setHasAccessToVideos(
      contractedTags.some((result) => result.id.startsWith('video'))
    );

    setHasAccessToInformatives(
      contractedTags.some((result) => result.id.startsWith('news'))
    );

    setHasPlatformAll(
      contractedTags.some((result) => result.id === 'platform-all')
    );
  }, [contractedTags]);

  const hasAccesToSomeContent =
    Boolean(session.client.all_content_view) ||
    hasAccessToPeriodics ||
    hasAccessToBooks ||
    hasAccessToVideos ||
    hasAccessToInformatives ||
    hasPlatformAll;

  const profile =
    session &&
    session.client &&
    session.client.profile !== undefined &&
    session.client.profile !== null
      ? session.client.profile
      : 1;

  const shouldShowRenewAlert =
    (profile === 1 || profile === 2) &&
    session.client.hasFutureContract === false;

  return (
    <>
      {shouldShowRenewAlert && (
        <Alert
          message="Atenção: o seu conteúdo está desatualizado!"
          description={`A vigência da sua última contratação finalizou em ${
            session.client.maxDateEndContract || 'data não informada'
          }. Para se manter sempre atualizado(a) e acessar os conteúdos mais recentes da FÓRUM, é necessário fazer a renovação do contrato. Para isso, entre em contato com: plataforma@editoraforum.com.br.`}
          type="warning"
          showIcon
          style={{
            marginBottom: 10,
            paddingBottom: 30,
            paddingTop: 30,
            borderRadius: 0,
            textAlign: 'center'
          }}
        />
      )}

      {!hasAccesToSomeContent && <NoAccessToAnyContent />}

      <CollapseContainer>
        {searchType === 'ai' ? <IAChat /> : <ContentListGlobal />}
      </CollapseContainer>
    </>
  );
};
